import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { BaseComponent } from "src/app/components/base/base-component.component";

@Component({
  selector: "app-content-replaced-dialog",
  template: 
		`<div class="default-modal" fxLayout="column">
              <div class="default-modal-header" fxLayout="row" fxLayoutAlign="space-between">
                <div mat-dialog-title name="content-replaced-title">Content Replaced</div>
                <button mat-icon-button name="content-replaced-close-button" [mat-dialog-close]="true" [disableRipple]="true" class="close-btn-modal" fxShow.md="true" fxShow.lg="true" fxShow.xl="true" fxShow="true">
                    <mat-icon>close</mat-icon>
                </button>
              </div>    
              <mat-dialog-content class="content">      
                <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start">
                  <div><b>This learning activity is no longer available.</b></div>
                  <div><b>Ask your tutor for a replacement or for next steps.</b></div>
                </div>
              </mat-dialog-content>
            </div>`,    
  styleUrls: ["./content-replaced-dialog.scss"]
})

export class ContentReplacedDialog extends BaseComponent {

  constructor(
    public dialog: MatDialogRef<ContentReplacedDialog>
    ) { super();  }
}